module.exports = __webpack_public_path__ + "static/1-ca726be261ef788245d36c1636a7a428.png";